/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStorageArticle } from './APIStorageArticle';
import {
    APIStorageArticleFromJSON,
    APIStorageArticleFromJSONTyped,
    APIStorageArticleToJSON,
} from './APIStorageArticle';

/**
 * 
 * @export
 * @interface APIPaginatedStorageArticleList
 */
export interface APIPaginatedStorageArticleList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedStorageArticleList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedStorageArticleList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedStorageArticleList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIStorageArticle>}
     * @memberof APIPaginatedStorageArticleList
     */
    results: Array<APIStorageArticle>;
}

/**
 * Check if a given object implements the APIPaginatedStorageArticleList interface.
 */
export function instanceOfAPIPaginatedStorageArticleList(value: object): value is APIPaginatedStorageArticleList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedStorageArticleListFromJSON(json: any): APIPaginatedStorageArticleList {
    return APIPaginatedStorageArticleListFromJSONTyped(json, false);
}

export function APIPaginatedStorageArticleListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedStorageArticleList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIStorageArticleFromJSON)),
    };
}

export function APIPaginatedStorageArticleListToJSON(value?: APIPaginatedStorageArticleList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIStorageArticleToJSON)),
    };
}

